export var IdHudLayout;
(function (IdHudLayout) {
    IdHudLayout["topLeft"] = "top-left";
    IdHudLayout["top"] = "top";
    IdHudLayout["topRight"] = "top-right";
    IdHudLayout["leftTop"] = "left-top";
    IdHudLayout["left"] = "left";
    IdHudLayout["center"] = "center";
    IdHudLayout["rightTop"] = "right-top";
    IdHudLayout["right"] = "right";
    IdHudLayout["bottomLeft"] = "bottom-left";
    IdHudLayout["bottom"] = "bottom";
    IdHudLayout["bottomRight"] = "bottom-right";
})(IdHudLayout || (IdHudLayout = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/hud/IdHudLayout.ts
// module id = 2262
// module chunks = 3